<template>
  <div id="login">
    <div class="bx">
      <!-- <div class="UpperLeftPoint">
        <div class="zsbox"></div>
      </div> -->
      <div class="logo">
        <div class="logobox"></div>
      </div>
      <!-- <div class="select"><span>{{ city }}</span></div> -->
      <!-- <el-select class="select" v-model="value" placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select> -->
      <div class="content">
        <div class="left_logo">
          <div class="left_banner"></div>
        </div>
        <div class="right_dlbox">
          <div class="dlmethod">
            <span class="wxsm" :class="tab ? 'active' : ''" @click="tab = true">微信扫码</span>
            <span class="zh" :class="tab ? '' : 'active'" @click="tab = false">账号<i style="font-size: 18px;">（用户名、密码）</i></span>
          </div>
          <div class="wxdl" v-show="tab">
            <!-- <div class="ewmimage" id="ewm"></div> -->
            <div class="wxbox">
              <div id="ewm" style="width:240px;height:240px"></div>
            </div>
            <p class="wxtext">请绑定微信“<span style="font-weight: bold;">扫一扫</span>”登录</p>
          </div>
          <div class="zhdl" v-show="!tab">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
              <el-form-item prop="accountNumb">
                <el-input placeholder="账号/手机号/用户名" v-model="ruleForm.accountNumb"></el-input>
              </el-form-item>
              <el-form-item prop="pwd">
                <el-input placeholder="初始密码：11111" v-model="ruleForm.pwd" type="password"></el-input>
              </el-form-item>
            </el-form>
            <div style="text-align: center;">
              <div class="btn" @click="loginFn">登录</div>
            </div>
            <p class="zhtext">请使用绑定账号登录</p>
          </div>
          <div class="wxtext2">
            <span @click="registerFn" style="margin-right: 15px;">立即注册</span>
            <!-- <span @click="bdwx" style="margin-right: 15px;">绑定微信</span> -->
            <i></i><span @click="passFn" style="margin-left: 15px;">修改密码</span>
            <!-- <i></i><span>忘记账号</span> -->
          </div>
          <div class="Tips">温馨提示：微信或账号为指定账号，有问题与管理员联系。</div>
        </div>
      </div>
      <div class="title">
        <p>北京金航联科技发展有限公司&nbsp;&nbsp;&nbsp;&nbsp;京ICP备09080402号-1</p>
        <p><span class="ga"></span>京公网安备 11010502045276号</p>
      </div>
    </div>
    <!-- <img :src="imageUrl" alt=""> -->
    <NewPwd
            :dialogVisible="dialogVisible"
            v-if="dialogVisible"
            @send="CloneFn"
      ></NewPwd>
    <el-dialog
      :visible.sync="dialogVisibleTwo"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      id="yzmdialog">
      <div class="yzmbox">
        <img :src="imageUrl" class="yzmImg" alt="">
        <el-input v-model="yzmInput" class="yzmInput"  placeholder="输入图中验证码"></el-input>
      </div>
      <div class="btnspan">
        <span class="tjbtn" @click="tjFn">提交</span>
        <span class="qxbtn" @click="qxFn">取消</span>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import api from "@/api";
import utils from '@/utils'
import NewPwd from "../components/NewPwd.vue";
export default {
  name:'login',
  components: {
    NewPwd,
  },
  data() {
    return {
      city:'',
      tab:false,
      dialogVisible:false,
      dialogVisibleTwo:false,
      options: [{
          value: '选项1',
          label: '北京'
        }, {
          value: '选项2',
          label: '南京'
        }, {
          value: '选项3',
          label: '天津'
        }, {
          value: '选项4',
          label: '武汉'
        }, {
          value: '选项5',
          label: '上海'
        }],
      value: '北京',
      ruleForm: {
        accountNumb:'',
          pwd:''
      },
      rules: {
        accountNumb: [
            { required: true, message: '请输入账号',trigger: 'blur' }
          ],
          pwd: [
            { required: true, message: '请输入密码', trigger: 'change' }
          ],
      },
      imageUrl:'',
      yzmInput:'',
    }
  },
  created() {
    // this.getLocalCity()
  },
  mounted() {
    this.wxchedFn()
  },
  methods:{
    wxchedFn() {
      this.$nextTick(()=>{
        const obj = new WxLogin({
	        id:"ewm",
	        appid: "wx8d491bb86915ed83", 
	        scope: "snsapi_login",
          redirect_uri: 'http%3A%2F%2Foaasa.mtnet.com.cn%2FWeChat',
	        state: "STATE",
	        style: "white",
          href:'data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDI0MHB4O21hcmdpbi10b3A6MHB4O2JvcmRlcjpub25lO30KLmltcG93ZXJCb3ggLnRpdGxlIHtkaXNwbGF5OiBub25lO30KLmltcG93ZXJCb3ggLmluZm8ge2Rpc3BsYXk6IG5vbmU7fQouc3RhdHVzX2ljb24ge2Rpc3BsYXk6IG5vbmV9Ci5pbXBvd2VyQm94IHt0ZXh0LWFsaWduOiBsZWZ0O30='
      });
    })
    // https://open.weixin.qq.com/connect/qrconnect?appid=APPID&redirect_uri=REDIRECT_URI&response_type=code&scope=SCOPE&state=STATE#wechat_redirect
    },
    bdwx() {
      location.href = 'https://open.weixin.qq.com/connect/qrconnect?appid=wx8d491bb86915ed83&redirect_uri=http%3A%2F%2Foaasa.mtnet.com.cn%2FWeChat&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect'
      // location.href = 'https://open.weixin.qq.com/connect/qrconnect?appid=wx8d491bb86915ed83&redirect_uri=http%3A%2F%2Foaasa.mtnet.com.cn%2Flogin&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect'
    },
    // 关闭密码
    CloneFn() {
      this.dialogVisible = false;
    },
    // 打开密码
    passFn() {
      this.dialogVisible = true;
    },
    getLocalCity() {
      var data = {key: 'IJCBZ-JRFKQ-JWL53-BHIRW-L6M3F-YZFZ4'} //申请的密钥
      var url = 'https://apis.map.qq.com/ws/location/v1/ip' //这个就是地理位置信息的接口
      data.output = 'jsonp'
      this.$jsonp(url, data).then((res) => {
        console.log(res);
        this.city = res.result.ad_info.city
      })
    },
    loginFn() {
      this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            console.log(valid);
            this.axios.post(api.Login,this.ruleForm).then((res) => {
                console.log(res);
               if(res.data.code == 200) {
                window.localStorage.setItem('Id',res.data.msg.id)
                window.localStorage.setItem('Img',res.data.msg.img_url)
                window.localStorage.setItem('TelePhone',res.data.msg.telePhone)
                window.localStorage.setItem('Name',res.data.msg.name)
                window.localStorage.setItem('Bm',res.data.msg.user_dept)
                 // 通过实例调用mutation方法
                this.$store.commit('user/setToken',res.data.msg.tokenstr)
                // 将在另一个公司使用的token存起来
                window.localStorage.setItem('tokenstr1',res.data.msg.tokenstr1)
                if(this.ruleForm.accountNumb == '王舒畅' || this.ruleForm.accountNumb == '胡晓硕' || this.ruleForm.accountNumb == '13514999246' || this.ruleForm.accountNumb == '18813178780') {
                  this.yzmFn()
                }else {
                  this.$router.push({name:'home'})
                }
               }
            })   
          } else {
            this.$message.error("请填写账号或密码");
            return false;
          }
      });
    },
    yzmFn(retryCount = 0, maxRetries = 3) {
      this.axios.get(api.validateCode_loadImage).then((res) => {
        if(res.data.msg) {
          if(res.data.msg.fileContent) { //有验证码图片，在弹窗中提交验证码
            this.imageUrl = `data:${res.data.msg.contentType};base64,${res.data.msg.fileContent}`;
            this.dialogVisibleTwo = true
          }else {  //没图片，可以直接登录
            this.$router.push({name:'home'})
          }
        }else {  //重新请求获取验证码
          if(retryCount < maxRetries) {
            // 延迟 1 秒后重试
            setTimeout(() => {
              this.yzmFn(retryCount + 1, maxRetries);
            }, 1000);
          } else {
            // 达到最大重试次数，显示错误信息
            this.$message.error('获取验证码失败，请稍后重试');
          }
        }
      }).catch((error) => {
        // 添加错误处理
        if(retryCount < maxRetries) {
          setTimeout(() => {
            this.yzmFn(retryCount + 1, maxRetries);
          }, 1000);
        } else {
          this.$message.error('网络错误，获取验证码失败');
        }
      });
    },
    registerFn() {
      this.$router.push({name:'register'})
    },
    tjFn() {
      let obj = {}
      obj.code = this.yzmInput
      this.axios.post(api.c4006_login,obj).then((res) => {
        if(res.data.code == 200) {
          if(res.data.msg == 1) {  //验证码通过，直接登录
            this.$router.push({name:'home'})
          }else if(res.data.msg == -1) {
            this.qxFn()
            this.$message.error('请重新登录')
          }else if(!res.data.msg) {
            this.$message.error('验证码错误')
          } 
        }
      })
    },
    qxFn() {
      this.dialogVisibleTwo = false
      this.yzmInput = ''
    },
  }
}

</script>

<style lang="less">
#login {
    .el-dialog {
    margin-top: 0 !important;
    background: transparent;
    box-shadow: none;
    width: 100%;
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      padding: 0;
    }
    .el-dialog__footer {
      padding: 0;
    }
  }
}
#yzmdialog {
  width: 300px;
	height: 260px;
  background-color: #fff;
	border-radius: 5px;
  margin-left: -150px;
  margin-top: -130px;
  top: 50%;
  left: 50%;
  .yzmbox {
    padding: 40px 20px 20px 20px;
    text-align: center;
    .yzmImg {
      width: 130px;
      height: 40px;
      margin-bottom: 20px;
    }
    .yzmInput {
      width: 130px;
    }
  }
}
</style>

<style lang="less">
#login {
  iframe {
    width: 240px !important;
    height: 240px !important;
    .qlogin_mod {
    margin-top: 20px;
    text-align: center;
    }
  }
  .el-input__inner {
    -webkit-appearance: none;
    background-color: #FFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    // -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    height: 42px;
    line-height: 42px;
    outline: 0;
    padding: 0 15px;
    // -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    width: 100%;
  }
  .el-input__prefix, .el-input__suffix {
    position: absolute;
    top: 8px;
    text-align: center;
  }
}
</style>

<style lang="less" scoped>
#login {
  // position: fixed;
  // top: 0;
  // left: 0;
  // right: 0;
  // bottom: 0;
  width: 100%;
  height: 1080px;
  background: url(../assets/login_bg.png) no-repeat;
  // background-size: cover;
  .UpperLeftPoint {
    padding-top: 15px;
    display: inline-block;
    .zsbox {
      width: 67px;
      height: 108px;
      background: url(../assets/UpperLeftPoint.png) no-repeat;
      background-size: 100% 100%;
    }
  }
  .bx {
    position: relative;
  }
  .logo {
    position: absolute;
    top: 87px;
    left: 0;
    // left: 90px;
    .logobox {
      width: 235px;
      height: 57px;
      background: url(../assets/logo.png) no-repeat;
      background-size: 100% 100%;
    }
  }
  .select {
    position: absolute;
    right: 0;
    top: 100px;
    width: 85px;
	  height: 26px;
    color: #ffffff;
    text-align: center;
    font-size: 16px;
	  border-radius: 10px;
	  border: solid 1px #2de0ff;
  }
  .content {
    width: 100%;
    height: 810px;
    padding-top: 190px;
    // margin: 0 auto;
    display: flex;
    .left_logo {
      width: 613px;
      height: 630px;
      // margin: 77px 100px 0 0;
      margin-right: 116px;
      display: flex;
      align-items: center;
      .left_banner {
        width: 582px;
        height: 84px;
        background: url(../assets/banner.png) no-repeat;
        background-size: 100% 100%;
      }
    }
    .right_dlbox {
      width: 470px;
      height: 630px;
      background: url(../assets/login_box.png) no-repeat;
      background-size: 100% 100%;
      .dlmethod {
        margin: 70px 35px;
        display: flex;
        .wxsm {
          width: 40%;
          font-size: 24px;
        }
        .zh {
          width: 60%;
          font-size: 24px;
        }
        span {
          line-height: 50px;
          text-align: center;
          font-family: 'SourceHanSansCN-Bold';
	        font-size: 20px;
          color: #444444;
          border-bottom: 1px solid #ccc;
          cursor: pointer;
        }
        .active {
          color: #0274fe;
          border-bottom: 1px solid #0274fe;
        }
      }
      .ewmimage {
        width: 208px;
        height: 208px;
        // background: url(../assets/QRcode.png) no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
      }
      .wxbox {
          display: flex;
          justify-content: center;
          align-items: center;
          // width: 220px;
          // height: 220px;
          // border: 1px solid #ccc;
          // padding: 15px;
          #ewm {
            width: 240px;
            height: 240px;
            background-color: #ccc;
          }
        }
        .zhdl {
          
        }
      .demo-ruleForm {
        width: 320px;
        height: 136px;
        margin: 0 auto;
        .el-form-item {
          margin-bottom: 26px;
        }
      }
      .btn {
        display: inline-block;
        width: 320px;
        height: 42px;
        line-height: 42px;
        background-image: linear-gradient(130deg, #2c97ff 0%, #49a5ff 100%), linear-gradient(#ffffff, #ffffff);
        background-blend-mode: normal, normal;
        -webkit-box-shadow: 0px 1px 0px 0px #3b8ad8;
        box-shadow: 0px 1px 0px 0px #3b8ad8;
        border-radius: 5px;
        text-align: center;
        color: #ffffff;
        cursor: pointer;
          // height: 46px;
          // width: 100%;
          // background-color: #49a5ff;
          // text-align: center; 
          // color: #ffffff;
          // font-size: 18px;
          // box-shadow:0px 1px 0px rgba(0,0,0,0.2);
        }
      .wxtext {
        font-family: 'SourceHanSansCN-Regular';
	      font-size: 16px;
        color: #444444;
        margin: 26px 0 45px 0;
        text-align: center;
      }
      .zhtext {
        font-family: 'SourceHanSansCN-Regular';
	      font-size: 16px;
        color: #444444;
        margin: 30px 0 75px 0;
        text-align: center;
      }
      .wxtext2 {
        font-family: 'SourceHanSansCN-Medium';
	      font-size: 16px;
        color: #000000;
        // text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 60px 40px 60px;
        span {
          height: 16px;
          line-height: 16px;
          text-align: center;
          cursor: pointer;
        }
        i {
          display: inline-block;
          width: 2px;
	        height: 16px;
	        background-color: #ededed;
        }
      }
      .Tips {
        margin: 0 18px;
        font-family: 'SourceHanSansCN-Regular';
	      font-size: 16px;
        color: #444444;
        border-top: 1px solid #ededed;
        text-align: center;
        line-height: 70px;
      }
    }
  }
  .title {
    // padding-left: 67px;
    font-family: 'SourceHanSansCN-Regular';
	  font-size: 16px;
    color: #494949;
    line-height: 30px;
    p {
      .ga {
        display: inline-block;
        vertical-align: middle;
        width: 16px;
        height: 18px;
        background: url(../assets/ga_icon.png) no-repeat;
        background-size: 100% 100%;
        margin-right: 2px;
        margin-bottom: 3px;
      }
    }
  }
  .Bottomrightpoint {
    position: absolute;
    right: 165px;
    bottom: -20px;
    .yxbox {
      width: 107px;
      height: 48px;
      background: url(../assets/Bottomrightpoint.png) no-repeat;
      background-size: 100% 100%;
    }
  }
  .btnspan {
        // margin: 10px 0;
        display: flex;
        justify-content: center;
        .tjbtn {
          display: inline-block;
          width: 88px;
	        height: 36px;
          line-height: 36px;
          text-align: center;
	        background-image: linear-gradient(130deg, 
	        	#2c97ff 0%, 
	        	#49a5ff 100%), 
	        linear-gradient(
	        	#ffffff, 
	        	#ffffff);
	        background-blend-mode: normal, 
	        	normal;
	        box-shadow: 0px 2px 0px 0px 
	        	#3b8ad8;
	        border-radius: 5px;
          color: #ffffff;
          margin-right: 15px;
          cursor: pointer;
        }
        .qxbtn {
          display: inline-block;
          width: 88px;
	        height: 38px;
          line-height: 36px;
          text-align: center;
	        background-color: #ffffff;
	        border-radius: 5px;
	        border: solid 1px #d2dce5;
          color: #46a4ff;
          cursor: pointer;
        }
      }
}
</style>


// WEBPACK FOOTER //
// src/view/login.vue